import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import GlobalComponent from '../components/global-configurations.component';
import { globals } from '../../../../../../redux/global/action';
import { selectGlobalsQueryItems } from '../../../../../../redux/global/selector';

const ManagementGlobal = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const globalsQuery = useSelector(selectGlobalsQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    chosenGlobalConfigurations,
    setChosenGlobalConfigurations
  ] = useState<any>([{
    DomainConfigurations: {
    },
    ServiceRequestConfigurations: {
      TimeToResolve: {}
    }
  }])
  const [
    chosenServiceRequest,
    setChosenServiceRequest
  ] = useState<any>({
    TimeToResolve:{}
  }) 
  const fetchGlobalsQueryById= ()=>{
    dispatch(globals.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/global-configurations/global/query`,entity:'globals',jsonData:{
          
    Records: [
      {
        Id: 0
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setChosenGlobalConfigurations({ ...chosenGlobalConfigurations, [fields[0]]: value });
    setChosenServiceRequest({ ...chosenServiceRequest, [fields[0]]: value });
  }
  useEffect(
    () => {
    
        fetchGlobalsQueryById()
        setIsLoading(false)

    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setChosenGlobalConfigurations(globalsQuery?.result?.items)
        setChosenServiceRequest((globalsQuery?.result?.items?.ServiceRequestConfigurations?.TimeToResolve))
      }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const globalData= {
        Id: chosenGlobalConfigurations?.Id || 0,
        DomainConfigurations: chosenGlobalConfigurations?.DomainConfigurations,
        ServiceRequestConfigurations:{
            TimeToResolve: chosenServiceRequest?.TimeToResolve
        }  
    }  
     dispatch(globals.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/global-configurations/global`,entity:'globals',jsonData:{
            
    Records: [
        globalData
    ]
 
}}))
.then(()=>{
    back()
  })
  }

const back=()=>{
  navigate('/management/configuration/global-configurations/global')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <GlobalComponent 
          periods={librariesItems?.MessageDelayPeriod}
          handleInnerFormChange={handleInnerFormChange}
          chosenGlobalConfigurations={chosenGlobalConfigurations}
          back={back}
          handleFormSubmit={handleFormSubmit}
          chosenServiceRequest={chosenServiceRequest}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementGlobal;